export enum BOIReportType {
    INITIAL = "INITIAL",
    UPDATED = "UPDATED",
    CORRECTED = "CORRECTED"
}